import { fmtDate } from "@/lib/api";
import PayableModule from "@/components/PayableModule";
import { Receipt } from "lucide-react";

export default function Charges() {
  return (
    <PayableModule
      endpoint="charges"
      title="Charges d'exploitation"
      subtitle="Loyer, salaires, fournitures, énergie… suivi des règlements"
      icon={Receipt}
      entityLabel="charge"
      emptyForm={{ libelle: "", categorie: "", beneficiaire: "", montant: 0, echeance: "", recurrence: "ponctuelle", notes: "" }}
      fields={[
        { key: "libelle", label: "Libellé", required: true, span: 2 },
        { key: "categorie", label: "Catégorie", type: "select", optionsKey: "charge_categories" },
        { key: "beneficiaire", label: "Bénéficiaire", type: "beneficiary" },
        { key: "montant", label: "Montant (FCFA)", type: "number", required: true },
        { key: "recurrence", label: "Récurrence", type: "select", options: ["ponctuelle", "mensuelle", "trimestrielle", "annuelle"] },
        { key: "date", label: "Date", type: "date" },
        { key: "echeance", label: "Échéance", type: "date" },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { label: "Libellé", render: (r) => <span className="font-semibold">{r.libelle}</span> },
        { label: "Catégorie", render: (r) => <span className="rounded bg-slate-100 px-2 py-0.5 text-xs">{r.categorie || "—"}</span> },
        { label: "Bénéficiaire", render: (r) => <span className="text-sm text-slate-600">{r.beneficiaire || "—"}</span> },
      ]}
    />
  );
}
